export const COLORS = [
  '#252525',
  '#85134b',
  '#021626',
  '#0074d9',
  '#001f3f',
  '#3e9970',
];
